var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 37.7318C20.4332 37.7318 22.7238 37.2418 24.8717 36.2618C27.0198 35.2819 28.9145 33.9284 30.556 32.2013C32.1976 30.4742 33.484 28.4807 34.4154 26.2208C35.3468 23.9609 35.8125 21.5509 35.8125 18.9909C35.8125 16.4308 35.3468 14.0208 34.4154 11.7609C33.484 9.501 32.1976 7.50749 30.556 5.78038C28.9145 4.05329 27.0168 2.69978 24.863 1.71987C22.7092 0.739957 20.4157 0.25 17.9825 0.25C15.5493 0.25 13.2587 0.739957 11.1107 1.71987C8.96276 2.69978 7.07092 4.05329 5.43519 5.78038C3.79947 7.50749 2.51593 9.501 1.58456 11.7609C0.653186 14.0208 0.1875 16.4308 0.1875 18.9909C0.1875 21.5509 0.653186 23.9609 1.58456 26.2208C2.51593 28.4807 3.80238 30.4742 5.44392 32.2013C7.08547 33.9284 8.98023 35.2819 11.1282 36.2618C13.2762 37.2418 15.5668 37.7318 18 37.7318Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8533 26.7443C14.4214 27.0271 14.0046 27.0753 13.6028 26.8889C13.2009 26.7024 13 26.3714 13 25.8956V12.0662C13 11.5905 13.2099 11.269 13.6298 11.1019C14.0496 10.9347 14.4574 10.9733 14.8533 11.2176L25.4331 17.9297C25.8049 18.1741 25.9938 18.5277 25.9999 18.9906C26.0059 19.4535 25.817 19.8136 25.4331 20.0707L14.8533 26.7443Z",
    fill: "#404B76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.ac13ff5cc864a10810b3bf97bc841982.svg";
export { ForwardRef as ReactComponent };